import { Grid } from "@mui/material";
import { Emptyable } from "@simplyk/common";

import { useTranslate } from "@/common/hooks/useTranslate";
import { DashboardButton } from "@/dashboard-design-system/DashboardButton";
import { DashboardTypography } from "@/dashboard-design-system/Typography/DashboardTypography";

export interface AdminBypassContentProps {
  isSubmitting: boolean;
  error: Emptyable<string>;
  onSubmit: () => Promise<void>;
}

export const AdminBypassContent = ({ isSubmitting, error, onSubmit }: AdminBypassContentProps) => {
  const { t } = useTranslate();

  return (
    <>
      <Grid item sx={{ width: "100%" }}>
        <DashboardTypography variant="body2">{t("dashboard", "twoFactor.adminBypass.helperText")}</DashboardTypography>
      </Grid>

      {error && (
        <Grid item sx={{ width: "100%" }}>
          <DashboardTypography variant="body2" sx={{ color: (theme) => theme.palette.error.main }}>
            {error}
          </DashboardTypography>
        </Grid>
      )}

      <Grid item sx={{ width: "100%" }}>
        <DashboardButton
          data-test="admin-bypass-submit-button"
          vibe="brand"
          variant="filled"
          fullWidth
          onClick={onSubmit}
          isLoading={isSubmitting}
          disabled={isSubmitting}
        >
          {t("dashboard", "twoFactor.adminBypass.submit")}
        </DashboardButton>
      </Grid>
    </>
  );
};
